import {
  ApplicationConfig,
  inject,
  importProvidersFrom,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners, provideZonelessChangeDetection
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { 
  provideClientHydration, 
  withEventReplay
} from '@angular/platform-browser';
import { providePrimeNG } from 'primeng/config';
import { DefaultTheme } from '@etninfinite/core';
import { provideHttpClient, HTTP_INTERCEPTORS,withInterceptorsFromDi } from '@angular/common/http';
import { TokenRefreshInterceptor } from './core/interceptors/token-refresh.interceptor';
import { OktaRefreshInterceptor } from './core/interceptors/okta-refresh-interceptor';
import { OktaAuthModule } from '@okta/okta-angular';
import { oktaConfig } from './shared/okta.config';
import OktaAuth from '@okta/okta-auth-js';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslationService } from './core/services/translation.service';

const oktaAuth = new OktaAuth(oktaConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes), 
    provideClientHydration(withEventReplay()),
    provideAnimations(),
    provideHttpClient(
      withInterceptorsFromDi(),
    ),
    providePrimeNG({
      theme: {
        preset: DefaultTheme,
        options: {
          darkModeSelector: false
        }
      }
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenRefreshInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OktaRefreshInterceptor,
      multi:true
    },
    provideAppInitializer(() => inject(TranslationService).initializeLanguage()),
    ...provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json'
      }),
      fallbackLang: 'en_US'
    }),
    importProvidersFrom(
      OktaAuthModule.forRoot({oktaAuth})
    )
  ]
};
